import { render, staticRenderFns } from "./recipe_builder.vue?vue&type=template&id=5d41d8ac&scoped=true&"
import script from "./recipe_builder.vue?vue&type=script&lang=js&"
export * from "./recipe_builder.vue?vue&type=script&lang=js&"
import style0 from "./recipe_builder.vue?vue&type=style&index=0&id=5d41d8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d41d8ac",
  null
  
)

export default component.exports